import image1 from '../../../../../Assets/images/OVIV/06-01.jpeg'
import image2 from '../../../../../Assets/images/OVIV/06-02.jpeg'
import image3 from '../../../../../Assets/images/OVIV/06-03.jpeg'



/* IMAGES LEVIVO GREENFIELD PARK*/

export const slidesLQOP1 = [
    {
        //MAIN IMAGE
        url: image2,
    },
    {
        url: image1,
    },
    {
        url: image3,
    },

]

export default slidesLQOP1;

